var map = {
	"./0xbtc.svg": [
		61078,
		61078
	],
	"./1inch.svg": [
		83536,
		83536
	],
	"./1st.svg": [
		9589,
		9589
	],
	"./aave.svg": [
		76057,
		76057
	],
	"./abbc.svg": [
		71695,
		71695
	],
	"./abt.svg": [
		54169,
		54169
	],
	"./ac3.svg": [
		31022,
		31022
	],
	"./act.svg": [
		86685,
		86685
	],
	"./ada.svg": [
		15467,
		15467
	],
	"./adb.svg": [
		46499,
		46499
	],
	"./adx.svg": [
		39207,
		39207
	],
	"./ae.svg": [
		64320,
		64320
	],
	"./aeon.svg": [
		16637,
		16637
	],
	"./aergo.svg": [
		83952,
		83952
	],
	"./agi.svg": [
		13664,
		13664
	],
	"./aion.svg": [
		36102,
		36102
	],
	"./ait.svg": [
		36412,
		36412
	],
	"./akro.svg": [
		77534,
		77534
	],
	"./akt.svg": [
		79929,
		79929
	],
	"./aleph.svg": [
		56304,
		56304
	],
	"./algo.svg": [
		71741,
		71741
	],
	"./alis.svg": [
		3291,
		3291
	],
	"./alpha.svg": [
		67460,
		67460
	],
	"./alx.svg": [
		35462,
		35462
	],
	"./amb.svg": [
		91727,
		91727
	],
	"./amlt.svg": [
		22072,
		22072
	],
	"./ampl.svg": [
		77585,
		77585
	],
	"./anc.svg": [
		6873,
		6873
	],
	"./anj.svg": [
		8552,
		8552
	],
	"./ankr.svg": [
		55334,
		55334
	],
	"./ant.svg": [
		72852,
		72852
	],
	"./aph.svg": [
		38785,
		38785
	],
	"./apl.svg": [
		21385,
		21385
	],
	"./appc.svg": [
		94805,
		94805
	],
	"./apy.svg": [
		16724,
		16724
	],
	"./ar.svg": [
		82849,
		82849
	],
	"./ardr.svg": [
		70357,
		70357
	],
	"./ark.svg": [
		78356,
		78356
	],
	"./arn.svg": [
		10500,
		10500
	],
	"./aro.svg": [
		21387,
		21387
	],
	"./arrr.svg": [
		59788,
		59788
	],
	"./ast.svg": [
		50169,
		50169
	],
	"./atmi.svg": [
		17814,
		17814
	],
	"./atom.svg": [
		6417,
		6417
	],
	"./auc.svg": [
		22295,
		22295
	],
	"./aura.svg": [
		6667,
		6667
	],
	"./avax.svg": [
		6226,
		6226
	],
	"./awc.svg": [
		54089,
		6363
	],
	"./axp.svg": [
		14050,
		14050
	],
	"./bac.svg": [
		33316,
		33316
	],
	"./bal.svg": [
		61922,
		61922
	],
	"./bam.svg": [
		76269,
		76269
	],
	"./band.svg": [
		13871,
		13871
	],
	"./bao.svg": [
		81449,
		81449
	],
	"./bat.svg": [
		19371,
		19371
	],
	"./bay.svg": [
		18873,
		18873
	],
	"./bbr.svg": [
		43226,
		43226
	],
	"./bcd.svg": [
		34690,
		34690
	],
	"./bch.svg": [
		12439,
		12439
	],
	"./bcn.svg": [
		79826,
		79826
	],
	"./bco.svg": [
		32974,
		32974
	],
	"./bf.svg": [
		76641,
		76641
	],
	"./bifi.svg": [
		15591,
		15591
	],
	"./bix.svg": [
		95904,
		95904
	],
	"./block.svg": [
		39928,
		39928
	],
	"./blt.svg": [
		76652,
		76652
	],
	"./blue.svg": [
		714,
		714
	],
	"./blz.svg": [
		39796,
		39796
	],
	"./bnb.svg": [
		23537,
		23537
	],
	"./bnt.svg": [
		33238,
		33238
	],
	"./bond.svg": [
		47694,
		47694
	],
	"./bora.svg": [
		6343,
		6343
	],
	"./box.svg": [
		64214,
		64214
	],
	"./bpt.svg": [
		27606,
		27606
	],
	"./bqx.svg": [
		61670,
		61670
	],
	"./brd.svg": [
		93272,
		99758
	],
	"./btc++.svg": [
		59975,
		59975
	],
	"./btc.svg": [
		51333,
		51333
	],
	"./btcd.svg": [
		52064,
		52064
	],
	"./btcp.svg": [
		93013,
		93013
	],
	"./btg.svg": [
		23552,
		23552
	],
	"./btmx.svg": [
		91544,
		91544
	],
	"./bto.svg": [
		4203,
		4203
	],
	"./bts.svg": [
		90873,
		90873
	],
	"./btt.svg": [
		33733,
		33733
	],
	"./btu.svg": [
		70282,
		70282
	],
	"./bu.svg": [
		26409,
		26409
	],
	"./busd.svg": [
		75088,
		75088
	],
	"./bwt.svg": [
		67743,
		67743
	],
	"./bz.svg": [
		4939,
		4939
	],
	"./bznt.svg": [
		46753,
		46753
	],
	"./bzrx.svg": [
		62034,
		62034
	],
	"./c20.svg": [
		28179,
		28179
	],
	"./cake.svg": [
		87055,
		87055
	],
	"./capp.svg": [
		91259,
		91259
	],
	"./car.svg": [
		83933,
		83933
	],
	"./card.svg": [
		92128,
		92128
	],
	"./cbat.svg": [
		49725,
		49725
	],
	"./cbc.svg": [
		22262,
		22262
	],
	"./cbt.svg": [
		28545,
		28545
	],
	"./cccx.svg": [
		72816,
		72816
	],
	"./cdai.svg": [
		68489,
		68489
	],
	"./cdt.svg": [
		66148,
		66148
	],
	"./cel.svg": [
		81850,
		81850
	],
	"./celr.svg": [
		59931,
		59931
	],
	"./cennz.svg": [
		83693,
		83693
	],
	"./ceth.svg": [
		31971,
		31971
	],
	"./cfx.svg": [
		63973,
		63973
	],
	"./chai.svg": [
		93762,
		93762
	],
	"./chat.svg": [
		22573,
		22573
	],
	"./chsb.svg": [
		91517,
		91517
	],
	"./chz.svg": [
		40866,
		40866
	],
	"./ckb.svg": [
		10930,
		10930
	],
	"./clo.svg": [
		50929,
		50929
	],
	"./cloak.svg": [
		35742,
		35742
	],
	"./cmt.svg": [
		22788,
		22788
	],
	"./cnd.svg": [
		27033,
		27033
	],
	"./cnx.svg": [
		55861,
		55861
	],
	"./comp.svg": [
		79551,
		79551
	],
	"./coni.svg": [
		20736,
		20736
	],
	"./cosm.svg": [
		72030,
		72030
	],
	"./coti.svg": [
		84902,
		84902
	],
	"./cov.svg": [
		34617,
		34617
	],
	"./cova.svg": [
		97335,
		97335
	],
	"./cpc.svg": [
		96873,
		96873
	],
	"./cpx.svg": [
		23058,
		23058
	],
	"./cre.svg": [
		96678,
		96678
	],
	"./cream.svg": [
		46016,
		46016
	],
	"./cred.svg": [
		72689,
		72689
	],
	"./crep.svg": [
		673,
		673
	],
	"./cro.svg": [
		30888,
		30888
	],
	"./crpt.svg": [
		59137,
		59137
	],
	"./crv.svg": [
		21318,
		21318
	],
	"./cs.svg": [
		90475,
		90475
	],
	"./csai.svg": [
		75174,
		75174
	],
	"./csc.svg": [
		24030,
		24030
	],
	"./ctc.svg": [
		39694,
		39694
	],
	"./ctxc.svg": [
		2181,
		2181
	],
	"./cube.svg": [
		12316,
		12316
	],
	"./cusdc.svg": [
		80999,
		80999
	],
	"./cv.svg": [
		92016,
		92016
	],
	"./cvc.svg": [
		1328,
		1328
	],
	"./cvt.svg": [
		41354,
		41354
	],
	"./cwbtc.svg": [
		32572,
		32572
	],
	"./czrx.svg": [
		9044,
		9044
	],
	"./dadi.svg": [
		63194,
		63194
	],
	"./dag.svg": [
		63537,
		63537
	],
	"./dai.svg": [
		87392,
		87392
	],
	"./dasc.svg": [
		56981,
		56981
	],
	"./dash.svg": [
		62729,
		62729
	],
	"./dat.svg": [
		70265,
		70265
	],
	"./data.svg": [
		85525,
		85525
	],
	"./datx.svg": [
		47107,
		47107
	],
	"./dbc.svg": [
		79018,
		79018
	],
	"./dcc.svg": [
		37142,
		37142
	],
	"./dcn.svg": [
		89621,
		89621
	],
	"./dcr.svg": [
		9832,
		9832
	],
	"./dct.svg": [
		70007,
		70007
	],
	"./ddd.svg": [
		73868,
		73868
	],
	"./default.svg": [
		41376
	],
	"./dent.svg": [
		1523,
		1523
	],
	"./dfi.svg": [
		60925,
		60925
	],
	"./dft.svg": [
		63495,
		63495
	],
	"./dgb.svg": [
		47039,
		47039
	],
	"./dgd.svg": [
		46979,
		46979
	],
	"./dgtx.svg": [
		39945,
		39945
	],
	"./divi.svg": [
		51874,
		51874
	],
	"./dlt.svg": [
		89900,
		89900
	],
	"./dmt.svg": [
		46174,
		46174
	],
	"./dnt.svg": [
		77632,
		77632
	],
	"./dock.svg": [
		54879,
		54879
	],
	"./dodo.svg": [
		69284,
		69284
	],
	"./doge.svg": [
		88238,
		88238
	],
	"./dor.svg": [
		83073,
		83073
	],
	"./dot.svg": [
		35965,
		35965
	],
	"./drgn.svg": [
		62352,
		62352
	],
	"./drop.svg": [
		54426,
		54426
	],
	"./dta.svg": [
		40931,
		40931
	],
	"./dtr.svg": [
		49038,
		49038
	],
	"./dtx.svg": [
		29490,
		29490
	],
	"./dxt.svg": [
		30778,
		30778
	],
	"./edg.svg": [
		90905,
		90905
	],
	"./edo.svg": [
		15923,
		15923
	],
	"./efx.svg": [
		6445,
		6445
	],
	"./egld.svg": [
		99167,
		99167
	],
	"./egt.svg": [
		418,
		418
	],
	"./ekg.svg": [
		43312,
		43312
	],
	"./ekt.svg": [
		70868,
		70868
	],
	"./ela.svg": [
		64447,
		64447
	],
	"./elec.svg": [
		35589,
		35589
	],
	"./elf.svg": [
		74899,
		74899
	],
	"./emc.svg": [
		44477,
		44477
	],
	"./emc2.svg": [
		30293,
		30293
	],
	"./eng.svg": [
		77101,
		77101
	],
	"./enj.svg": [
		90683,
		90683
	],
	"./eos.svg": [
		63734,
		63734
	],
	"./eosdac.svg": [
		32179,
		32179
	],
	"./erd.svg": [
		53816,
		53816
	],
	"./ern.svg": [
		77852,
		77852
	],
	"./esd.svg": [
		1827,
		1827
	],
	"./esp.svg": [
		78850,
		78850
	],
	"./ess.svg": [
		90588,
		90588
	],
	"./etc.svg": [
		46818,
		46818
	],
	"./eth.svg": [
		87606,
		87606
	],
	"./etn.svg": [
		7486,
		7486
	],
	"./etp.svg": [
		62907,
		62907
	],
	"./etz.svg": [
		6378,
		6378
	],
	"./evx.svg": [
		36968,
		36968
	],
	"./ewt.svg": [
		39539,
		39539
	],
	"./exrn.svg": [
		8378,
		8378
	],
	"./exy.svg": [
		10783,
		10783
	],
	"./fct.svg": [
		29155,
		29155
	],
	"./fet.svg": [
		61856,
		61856
	],
	"./fil.svg": [
		82430,
		82430
	],
	"./flow.svg": [
		612,
		612
	],
	"./fota.svg": [
		40843,
		40843
	],
	"./frm.svg": [
		73499,
		73499
	],
	"./fsn.svg": [
		81174,
		81174
	],
	"./ft.svg": [
		85242,
		85242
	],
	"./ftm.svg": [
		92780,
		92780
	],
	"./ftt.svg": [
		83733,
		83733
	],
	"./fuel.svg": [
		82504,
		82504
	],
	"./fun.svg": [
		48042,
		48042
	],
	"./fxc.svg": [
		86432,
		86432
	],
	"./fxt.svg": [
		75754,
		75754
	],
	"./gala.svg": [
		13405,
		13405
	],
	"./gdc.svg": [
		16782,
		16782
	],
	"./gem.svg": [
		4283,
		4283
	],
	"./gen.svg": [
		35687,
		35687
	],
	"./gno.svg": [
		73424,
		73424
	],
	"./gnt.svg": [
		51851,
		51851
	],
	"./gnx.svg": [
		52044,
		52044
	],
	"./go.svg": [
		39772,
		39772
	],
	"./goc.svg": [
		67587,
		67587
	],
	"./got.svg": [
		35263,
		35263
	],
	"./grin.svg": [
		87705,
		87705
	],
	"./grs.svg": [
		23376,
		23376
	],
	"./grt.svg": [
		89986,
		89986
	],
	"./gsc.svg": [
		23498,
		23498
	],
	"./gt.svg": [
		96771,
		96771
	],
	"./gtc.svg": [
		27096,
		27096
	],
	"./gto.svg": [
		71101,
		93272
	],
	"./gusd.svg": [
		8896,
		8896
	],
	"./gvt.svg": [
		50447,
		50447
	],
	"./gxs.svg": [
		68792,
		68792
	],
	"./hav.svg": [
		17440,
		17440
	],
	"./hbar.svg": [
		88830,
		88830
	],
	"./hc.svg": [
		47417,
		47417
	],
	"./hedg.svg": [
		40365,
		40365
	],
	"./her.svg": [
		77608,
		77608
	],
	"./hex.svg": [
		23800,
		23800
	],
	"./hive.svg": [
		7862,
		7862
	],
	"./hot-x.svg": [
		10553,
		10553
	],
	"./hot.svg": [
		96168,
		96168
	],
	"./hpb.svg": [
		11492,
		11492
	],
	"./hsr.svg": [
		47951,
		47951
	],
	"./ht.svg": [
		69286,
		69286
	],
	"./hum.svg": [
		12893,
		12893
	],
	"./husd.svg": [
		2815,
		2815
	],
	"./hvn.svg": [
		41049,
		41049
	],
	"./hydro.svg": [
		20815,
		20815
	],
	"./hyn.svg": [
		41197,
		41197
	],
	"./ibat.svg": [
		28961,
		28961
	],
	"./icn.svg": [
		70207,
		70207
	],
	"./icx.svg": [
		89252,
		89252
	],
	"./idai.svg": [
		63934,
		63934
	],
	"./idex.svg": [
		80297,
		80297
	],
	"./ieth.svg": [
		74759,
		74759
	],
	"./ignis.svg": [
		21819,
		21819
	],
	"./iknc.svg": [
		66351,
		66351
	],
	"./ilink.svg": [
		39914,
		39914
	],
	"./inb.svg": [
		35171,
		35171
	],
	"./ins.svg": [
		12365,
		12365
	],
	"./iost.svg": [
		58526,
		58526
	],
	"./iota.svg": [
		67116,
		67116
	],
	"./iotx.svg": [
		20586,
		20586
	],
	"./iq.svg": [
		32954,
		32954
	],
	"./irep.svg": [
		68150,
		68150
	],
	"./iris.svg": [
		96051,
		96051
	],
	"./isusd.svg": [
		88391,
		88391
	],
	"./iusdc.svg": [
		91951,
		91951
	],
	"./iwbtc.svg": [
		30334,
		30334
	],
	"./izrx.svg": [
		24294,
		24294
	],
	"./jnt.svg": [
		93903,
		93903
	],
	"./jrt.svg": [
		84708,
		84708
	],
	"./jst.svg": [
		96501,
		96501
	],
	"./kava.svg": [
		60239,
		60239
	],
	"./kcs.svg": [
		50429,
		50429
	],
	"./keep.svg": [
		60250,
		60250
	],
	"./key.svg": [
		49694,
		49694
	],
	"./kick.svg": [
		9539,
		9539
	],
	"./kin.svg": [
		62911,
		62911
	],
	"./klv.svg": [
		10705,
		10705
	],
	"./kmd.svg": [
		20530,
		20530
	],
	"./knc.svg": [
		85886,
		85886
	],
	"./ksm.svg": [
		16269,
		16269
	],
	"./lamb.svg": [
		11184,
		11184
	],
	"./land.svg": [
		65927,
		65927
	],
	"./lba.svg": [
		96685,
		96685
	],
	"./ldo.svg": [
		3841,
		3841
	],
	"./lend.svg": [
		80541,
		80541
	],
	"./leo.svg": [
		61529,
		61529
	],
	"./link.svg": [
		64097,
		64097
	],
	"./lit.svg": [
		4876,
		4876
	],
	"./lky.svg": [
		22373,
		22373
	],
	"./loki.svg": [
		65935,
		65935
	],
	"./lon.svg": [
		98849,
		98849
	],
	"./loom.svg": [
		69866,
		69866
	],
	"./lpt.svg": [
		77432,
		77432
	],
	"./lqd.svg": [
		17900,
		17900
	],
	"./lrc.svg": [
		77106,
		77106
	],
	"./lsk.svg": [
		18898,
		18898
	],
	"./ltc.svg": [
		4026,
		4026
	],
	"./lto.svg": [
		23326,
		23326
	],
	"./lun.svg": [
		69234,
		69234
	],
	"./luna.svg": [
		94512,
		94512
	],
	"./lxt.svg": [
		39934,
		39934
	],
	"./lym.svg": [
		55880,
		55880
	],
	"./maid.svg": [
		89499,
		89499
	],
	"./man.svg": [
		95312,
		95312
	],
	"./mana-old.svg": [
		41272,
		41272
	],
	"./mana.svg": [
		71008,
		71008
	],
	"./math.svg": [
		25651,
		25651
	],
	"./matic.svg": [
		49143,
		49143
	],
	"./mbc.svg": [
		7732,
		7732
	],
	"./mco.svg": [
		32908,
		32908
	],
	"./mcx.svg": [
		74595,
		74595
	],
	"./mda.svg": [
		2242,
		2242
	],
	"./mds.svg": [
		56828,
		56828
	],
	"./med.svg": [
		37768,
		37768
	],
	"./medx.svg": [
		34368,
		34368
	],
	"./met.svg": [
		22447,
		22447
	],
	"./mfg.svg": [
		6881,
		6881
	],
	"./mft.svg": [
		18999,
		18999
	],
	"./mir.svg": [
		47219,
		47219
	],
	"./mith.svg": [
		56432,
		56432
	],
	"./mkr.svg": [
		3802,
		3802
	],
	"./mln.svg": [
		60198,
		60198
	],
	"./mod.svg": [
		90002,
		90002
	],
	"./mot.svg": [
		61216,
		61216
	],
	"./mta.svg": [
		62135,
		62135
	],
	"./mth.svg": [
		29649,
		29649
	],
	"./mtl.svg": [
		7160,
		7160
	],
	"./mtn.svg": [
		58335,
		58335
	],
	"./mvc.svg": [
		22902,
		22902
	],
	"./mvl.svg": [
		66435,
		28471
	],
	"./mvp.svg": [
		90515,
		90515
	],
	"./mwat.svg": [
		46454,
		46454
	],
	"./mwc.svg": [
		17612,
		17612
	],
	"./mxm.svg": [
		6573,
		6573
	],
	"./myb.svg": [
		34965,
		34965
	],
	"./nano.svg": [
		62503,
		62503
	],
	"./nas.svg": [
		83405,
		83405
	],
	"./nav.svg": [
		96569,
		96569
	],
	"./ncash.svg": [
		22538,
		22538
	],
	"./nct.svg": [
		96640,
		96640
	],
	"./near.svg": [
		41959,
		41959
	],
	"./nebl.svg": [
		51323,
		51323
	],
	"./nec.svg": [
		59312,
		59312
	],
	"./neo.svg": [
		23493,
		23493
	],
	"./new.svg": [
		98015,
		98015
	],
	"./nex.svg": [
		66611,
		66611
	],
	"./nexo.svg": [
		7621,
		7621
	],
	"./nexxo.svg": [
		32120,
		32120
	],
	"./ngc.svg": [
		93360,
		93360
	],
	"./nkn.svg": [
		29642,
		29642
	],
	"./nmr.svg": [
		35041,
		35041
	],
	"./noia.svg": [
		7964,
		7964
	],
	"./nper.svg": [
		28754,
		28754
	],
	"./npxs.svg": [
		14497,
		14497
	],
	"./nrg.svg": [
		81916,
		81916
	],
	"./nrve.svg": [
		78332,
		78332
	],
	"./nu.svg": [
		45909,
		45909
	],
	"./nuls.svg": [
		96198,
		96198
	],
	"./nxs.svg": [
		57132,
		57132
	],
	"./nxt.svg": [
		20584,
		20584
	],
	"./oag.svg": [
		78277,
		78277
	],
	"./oax.svg": [
		14426,
		14426
	],
	"./ocean.svg": [
		49616,
		49616
	],
	"./ocn.svg": [
		56056,
		56056
	],
	"./ode.svg": [
		75535,
		75535
	],
	"./ogn.svg": [
		97885,
		97885
	],
	"./okb.svg": [
		92257,
		92257
	],
	"./olt.svg": [
		55610,
		55610
	],
	"./omg.svg": [
		43939,
		43939
	],
	"./one.svg": [
		76999,
		76999
	],
	"./onion.svg": [
		29015,
		29015
	],
	"./ont.svg": [
		87375,
		87375
	],
	"./open.svg": [
		79397,
		79397
	],
	"./orbs.svg": [
		36434,
		36434
	],
	"./orc.svg": [
		25177,
		25177
	],
	"./orn.svg": [
		74104,
		74104
	],
	"./ost.svg": [
		72864,
		72864
	],
	"./ovc.svg": [
		53596,
		53596
	],
	"./oxt.svg": [
		34925,
		34925
	],
	"./pBTC.svg": [
		47933,
		47933
	],
	"./pai.svg": [
		81611,
		81611
	],
	"./pal.svg": [
		73303,
		73303
	],
	"./part.svg": [
		7824,
		7824
	],
	"./pax.svg": [
		68560,
		68560
	],
	"./paxg.svg": [
		76498,
		76498
	],
	"./pay.svg": [
		64115,
		64115
	],
	"./perl.svg": [
		3763,
		3763
	],
	"./pivx.svg": [
		96514,
		96514
	],
	"./plDAI.svg": [
		11263,
		11263
	],
	"./plUSDC.svg": [
		39378,
		39378
	],
	"./play.svg": [
		69838,
		69838
	],
	"./plr.svg": [
		32636,
		32636
	],
	"./png.svg": [
		68048,
		68048
	],
	"./pnk.svg": [
		48623,
		48623
	],
	"./pnt.svg": [
		73283,
		73283
	],
	"./poa.svg": [
		90558,
		90558
	],
	"./poe.svg": [
		51889,
		51889
	],
	"./poly.svg": [
		34279,
		34279
	],
	"./pond.svg": [
		60300,
		60300
	],
	"./powr.svg": [
		3918,
		3918
	],
	"./ppay.svg": [
		9498,
		9498
	],
	"./ppc.svg": [
		56989,
		56989
	],
	"./ppp.svg": [
		27269,
		27269
	],
	"./ppt.svg": [
		44121,
		44121
	],
	"./pre.svg": [
		15036,
		15036
	],
	"./prl.svg": [
		75219,
		75219
	],
	"./pro.svg": [
		66519,
		66519
	],
	"./prq.svg": [
		696,
		696
	],
	"./pst.svg": [
		68889,
		68889
	],
	"./qash.svg": [
		81069,
		81069
	],
	"./qbit.svg": [
		10230,
		10230
	],
	"./qkc.svg": [
		57923,
		57923
	],
	"./qlc.svg": [
		61925,
		61925
	],
	"./qnt.svg": [
		42329,
		42329
	],
	"./qsp.svg": [
		29446,
		29446
	],
	"./qtum.svg": [
		37121,
		37121
	],
	"./r.svg": [
		68308,
		68308
	],
	"./rae.svg": [
		15642,
		15642
	],
	"./rari.svg": [
		79190,
		79190
	],
	"./ray.svg": [
		80898,
		80898
	],
	"./rcn.svg": [
		31882,
		31882
	],
	"./rdd.svg": [
		93325,
		93325
	],
	"./rdn.svg": [
		64583,
		64583
	],
	"./ren.svg": [
		37422,
		37422
	],
	"./rep.svg": [
		74436,
		74436
	],
	"./req.svg": [
		13094,
		13094
	],
	"./rev.svg": [
		1448,
		1448
	],
	"./rfox.svg": [
		61967,
		61967
	],
	"./rhoc.svg": [
		17947,
		17947
	],
	"./rif.svg": [
		46464,
		46464
	],
	"./rlc.svg": [
		10233,
		10233
	],
	"./rose.svg": [
		14145,
		14145
	],
	"./rpx.svg": [
		9229,
		9229
	],
	"./rsr.svg": [
		38182,
		38182
	],
	"./rsv.svg": [
		96738,
		96738
	],
	"./rune.svg": [
		94687,
		94687
	],
	"./rvn.svg": [
		74330,
		74330
	],
	"./s.svg": [
		47186,
		47186
	],
	"./sai.svg": [
		37791,
		37791
	],
	"./salt.svg": [
		35067,
		35067
	],
	"./san.svg": [
		90340,
		90340
	],
	"./scrl.svg": [
		95397,
		95397
	],
	"./scrt.svg": [
		35765,
		35765
	],
	"./seele.svg": [
		26028,
		26028
	],
	"./sem.svg": [
		41299,
		41299
	],
	"./sfp.svg": [
		95477,
		95477
	],
	"./shr.svg": [
		32254,
		32254
	],
	"./shuf.svg": [
		55584,
		55584
	],
	"./sia.svg": [
		70554,
		70554
	],
	"./skl.svg": [
		36592,
		36592
	],
	"./sky.svg": [
		25595,
		25595
	],
	"./slt.svg": [
		38374,
		38374
	],
	"./smart.svg": [
		16798,
		16798
	],
	"./snc.svg": [
		84663,
		84663
	],
	"./sngls.svg": [
		98264,
		98264
	],
	"./snm.svg": [
		42240,
		42240
	],
	"./snt.svg": [
		21252,
		21252
	],
	"./snx.svg": [
		48082,
		48082
	],
	"./sol.svg": [
		38679,
		38679
	],
	"./soul.svg": [
		68115,
		68115
	],
	"./spn.svg": [
		11025,
		11025
	],
	"./srm.svg": [
		82104,
		82104
	],
	"./stake.svg": [
		30849,
		30849
	],
	"./steem.svg": [
		52537,
		52537
	],
	"./steth.svg": [
		27322,
		27322
	],
	"./stmx.svg": [
		43565,
		43565
	],
	"./storj.svg": [
		19787,
		19787
	],
	"./storm.svg": [
		44227,
		44227
	],
	"./strat.svg": [
		79502,
		79502
	],
	"./stx.svg": [
		98814,
		98814
	],
	"./sub.svg": [
		23620,
		23620
	],
	"./super.svg": [
		67809,
		67809
	],
	"./suqa.svg": [
		40406,
		40406
	],
	"./sushi.svg": [
		98209,
		98209
	],
	"./suter.svg": [
		82004,
		82004
	],
	"./swap.svg": [
		96145,
		96145
	],
	"./swth.svg": [
		81141,
		81141
	],
	"./sxdt.svg": [
		6961,
		6961
	],
	"./sxp.svg": [
		30297,
		30297
	],
	"./sys.svg": [
		78006,
		78006
	],
	"./tct.svg": [
		3342,
		3342
	],
	"./tel.svg": [
		7091,
		7091
	],
	"./tfuel.svg": [
		80558,
		80558
	],
	"./thc.svg": [
		74342,
		74342
	],
	"./theta.svg": [
		76953,
		76953
	],
	"./thr.svg": [
		11692,
		11692
	],
	"./tio.svg": [
		39411,
		39411
	],
	"./titan.svg": [
		81829,
		81829
	],
	"./tkn.svg": [
		15908,
		15908
	],
	"./tky.svg": [
		97350,
		97350
	],
	"./tnb.svg": [
		69983,
		69983
	],
	"./tnc.svg": [
		54083,
		54083
	],
	"./tnt.svg": [
		81306,
		81306
	],
	"./tomo.svg": [
		33230,
		33230
	],
	"./tpay.svg": [
		2461,
		2461
	],
	"./trac.svg": [
		5254,
		5254
	],
	"./trb.svg": [
		59582,
		59582
	],
	"./trig.svg": [
		78451,
		78451
	],
	"./trtl.svg": [
		3940,
		3940
	],
	"./trx.svg": [
		75309,
		75309
	],
	"./tryb.svg": [
		70354,
		70354
	],
	"./ttc.svg": [
		13045,
		13045
	],
	"./tube.svg": [
		93716,
		93716
	],
	"./tusd.svg": [
		37277,
		37277
	],
	"./ubq.svg": [
		67154,
		16182
	],
	"./ubt.svg": [
		55609,
		55609
	],
	"./ult.svg": [
		63398,
		63398
	],
	"./uma.svg": [
		56967,
		56967
	],
	"./unfi.svg": [
		81690,
		81690
	],
	"./uni.svg": [
		37389,
		37389
	],
	"./unn.svg": [
		46338,
		46338
	],
	"./uos.svg": [
		12602,
		12602
	],
	"./upp.svg": [
		65371,
		65371
	],
	"./usd.svg": [
		85515,
		85515
	],
	"./usdc.svg": [
		97694,
		97694
	],
	"./usds.svg": [
		99957,
		99957
	],
	"./usdt.svg": [
		8332,
		8332
	],
	"./utk.svg": [
		4414,
		4414
	],
	"./uuu.svg": [
		46982,
		46982
	],
	"./veri.svg": [
		92812,
		92812
	],
	"./vest.svg": [
		39482,
		39482
	],
	"./vet.svg": [
		74766,
		74766
	],
	"./via.svg": [
		42384,
		42384
	],
	"./vib.svg": [
		10408,
		10408
	],
	"./vibe.svg": [
		58282,
		58282
	],
	"./vidt.svg": [
		20030,
		20030
	],
	"./vikky.svg": [
		7884,
		7884
	],
	"./vin.svg": [
		25099,
		25099
	],
	"./vite.svg": [
		59682,
		59682
	],
	"./viu.svg": [
		52548,
		52548
	],
	"./vlx.svg": [
		93314,
		93314
	],
	"./vrs.svg": [
		66215,
		66215
	],
	"./vsp.svg": [
		36603,
		36603
	],
	"./vsys.svg": [
		59601,
		59601
	],
	"./vtc.svg": [
		72213,
		72213
	],
	"./wabi.svg": [
		12246,
		12246
	],
	"./wan.svg": [
		11856,
		11856
	],
	"./waves.svg": [
		35081,
		35081
	],
	"./wbtc.svg": [
		17224,
		17224
	],
	"./wct.svg": [
		93225,
		93225
	],
	"./whale.svg": [
		16165,
		16165
	],
	"./wib.svg": [
		17690,
		17690
	],
	"./wings.svg": [
		542,
		542
	],
	"./woo.svg": [
		38286,
		38286
	],
	"./wpr.svg": [
		68111,
		68111
	],
	"./wrx.svg": [
		74750,
		74750
	],
	"./wtc.svg": [
		28636,
		28636
	],
	"./wxt.svg": [
		86694,
		86694
	],
	"./xas.svg": [
		63073,
		63073
	],
	"./xchf.svg": [
		48650,
		48650
	],
	"./xem.svg": [
		20184,
		20184
	],
	"./xin.svg": [
		50222,
		50222
	],
	"./xlm.svg": [
		87473,
		87473
	],
	"./xlq.svg": [
		89653,
		89653
	],
	"./xmark.svg": [
		23673,
		23673
	],
	"./xmr.svg": [
		99736,
		99736
	],
	"./xmx.svg": [
		44274,
		44274
	],
	"./xnk.svg": [
		58253,
		58253
	],
	"./xns.svg": [
		58754,
		58754
	],
	"./xor.svg": [
		92796,
		92796
	],
	"./xrp.svg": [
		55508,
		55508
	],
	"./xsn.svg": [
		11249,
		11249
	],
	"./xsr.svg": [
		71319,
		71319
	],
	"./xtz.svg": [
		37739,
		37739
	],
	"./xvg.svg": [
		31496,
		31496
	],
	"./xyo.svg": [
		84299,
		84299
	],
	"./xzc.svg": [
		86890,
		86890
	],
	"./yfi.svg": [
		78887,
		78887
	],
	"./yoyo.svg": [
		60989,
		60989
	],
	"./zai.svg": [
		13183,
		13183
	],
	"./zb.svg": [
		94126,
		94126
	],
	"./zco.svg": [
		78840,
		78840
	],
	"./zec.svg": [
		77802,
		77802
	],
	"./zel.svg": [
		92777,
		92777
	],
	"./zen.svg": [
		72451,
		72451
	],
	"./zil.svg": [
		5308,
		5308
	],
	"./zks.svg": [
		46729,
		46729
	],
	"./zrx.svg": [
		15384,
		15384
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21730;
module.exports = webpackAsyncContext;